import React, {Component} from "react";
import {Link, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import {logIn} from "../../redux/actions/user";

class Auth extends Component {
	state = {
		login    : '',
		password : '',
	};

	constructor(props) {
		super(props);
	}

	changeLogin(e) {
		this.setState({
			login : e.target.value
		});
	}

	changePassword(e) {
		this.setState({
			password : e.target.value
		});
	}

	login() {
		this.props.onLogin(this.state.login, this.state.password);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return JSON.stringify(nextProps.user) !== JSON.stringify(this.props.user) || nextState !== this.state;
	}

	goAuth(e) {
		if ( e.key === 'Enter' ) {
			this.login();
		}
	}

	render() {
		if ( this.props.user.login.auth ) {
			return <Redirect to={'/'}/>;
		}

		return (
			<div className="register">
				<div className="register__title">Авторизация</div>
				<div className="register__data auth">

					{/*E-mail*/}
					<div className="register__data-header">
						<label htmlFor="login">Логин</label>
					</div>
					<div className="register__data-input_row">
						<div className="data">
							<input type="text"
							       id="login"
							       name="login"
							       value={this.state.login}
							       onKeyPress={this.goAuth.bind(this)}
							       onChange={this.changeLogin.bind(this)}/>
						</div>
					</div>

					{/*Пароль*/}
					<div className="register__data-header">
						<label htmlFor="password">Пароль</label>
					</div>
					<div className="register__data-input_row">
						<div className="data">
							<input type="password"
							       id="password"
							       name="password"
							       value={this.state.password}
							       onKeyPress={this.goAuth.bind(this)}
							       onChange={this.changePassword.bind(this)}/>
						</div>
					</div>

					<div className="register__data-input_row between">
						<div className="checkbox data remember">
							<Link to={'/user/signup'}>Регистрация</Link>
						</div>
						<div className="data htmlForgotten">
							<Link to={'/user/forgot'}>Забыли пароль?</Link>
						</div>
					</div>

					<div className="register__data-buttons auth buttons">
						<button className="buttons__show" onClick={this.login.bind(this)}>Войти</button>
						<div>{this.props.user.fetching && <Loading/>}</div>
						{this.props.user.messages.length > 0 &&
						<div className="register__data-warning margin">{this.props.user.messages.join('; ')}</div>}
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({
		onLogin : (login, password) => {
			dispatch(logIn(login, password));
		}
	})
)
(Auth);


// WEBPACK FOOTER //
// ./src/app/pages/Auth/Auth.js